export default __webpack_public_path__ + "static/media/logo2.95c89ee1.svg";